import React from "react";
import ReactDOM from "react-dom/client";
// Toasts are shown before any page loads Generic (which also imports it): first in the cascade.
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import UiLabelsBridge from "./components/UiLabelsBridge";
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthProvider";
import ApiInterceptors from "./components/ApiInterceptors";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from 'react-redux'

import './styles/index.scss'
import store from "./context/store";

if (process.env.NODE_ENV === "production") {
  disableReactDevTools();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Provider store={store}>
      <AuthProvider>
        {/* once for the whole app, before the routes (see components/ApiInterceptors) */}
        <ApiInterceptors />
        <Routes>
          <Route path="/*" exact element={<UiLabelsBridge><App /></UiLabelsBridge>} />
        </Routes>
      </AuthProvider>

      </Provider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
